import { BiSolidChevronLeft, BiSolidChevronRight } from "react-icons/bi";
import Container from "./components/Container";
import Slider from "./components/Slider";
import "./styles/App.css";
import { useState } from "react";
import { patternsFlow } from "./helpers/fragments";
import { views } from "./config/settings";

function App() {
   const [viewNum, setViewNum] = useState(0);
   function switchPattern(dir) {
      setViewNum((curr) => Math.abs((curr + dir) % views.length));
   }
   return (
      <div className="App">
         <div className="slider_button left" onClick={() => switchPattern(-1)}>
            <BiSolidChevronLeft size={35} />
         </div>
         <div className="slider_button right" onClick={() => switchPattern(1)}>
            <BiSolidChevronRight size={35} />{" "}
         </div>
         <div>
         </div>
         <Container pattern={patternsFlow[viewNum % patternsFlow.length]}>
            <Slider viewNum = {viewNum} />
         </Container>
      </div>
   );
}

export default App;
